import styled from 'styled-components';

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
